import { FC } from 'react';

import { AnimatePresence, MotionProps, motion } from 'framer-motion';

type RollingProps = MotionProps & {
  variable: boolean;
};

export const Rolling: FC<RollingProps> = ({ children, variable, ...rest }) => {
  return (
    <AnimatePresence exitBeforeEnter initial={false}>
      <motion.div
        key={String(variable)}
        initial={{ y: variable ? 10 : -10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: variable ? 10 : -10, opacity: 0 }}
        transition={{ duration: 0.15 }}
        {...rest}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
